import React from 'react';
import Breadcrumb from '../navigation/Breadcrumb';
import './PageLayout.css';

function PageLayout({ children, title, subtitle, showBreadcrumb = true }) {
  return (
    <div className="page-layout">
      {showBreadcrumb && <Breadcrumb />}
      
      <div className="page-header">
        {title && <h1 className="page-title">{title}</h1>}
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      
      <div className="page-content">
        {children}
      </div>
    </div>
  );
}

export default PageLayout;